import { Backbone } from "extensions/backbone";

import { TabModel } from "./tabModel";

export const TabsCollection = Backbone.Collection.extend({
    model: TabModel
});
